import Banner from 'components/Banner';
import PanelSection from 'components/PanelSection';

import { PH_DECIMAL_PRECISION, TEST_ID } from './constants';
import type { FunctionComponent, PhDescriber, PhFinding, Props } from './types';

import styles from './styles.module.scss';

const buildPhText = (
    finding: PhFinding,
    describeAbove: PhDescriber,
    describeBelow: PhDescriber
): string => {
    const threshold = finding.thresholdPh.toFixed(PH_DECIMAL_PRECISION);
    const observed = finding.observedPh.toFixed(PH_DECIMAL_PRECISION);

    if (finding.direction === 'ABOVE') {
        return `${finding.ingredientName}: ${describeAbove(threshold, observed)}`;
    }

    return `${finding.ingredientName}: ${describeBelow(threshold, observed)}`;
};

const PhWarningsSection: FunctionComponent<Props> = ({
    className = '',
    describeAbove,
    describeBelow,
    phWarnings,
    severityToBannerVariant,
    testId = TEST_ID,
    title
}) => (
    <PanelSection
        className={`${styles.phWarningsSection} ${className}`}
        testId={testId}
        text={title}>
        {phWarnings.map(finding => (
            <Banner
                icon='info'
                key={`${finding.ingredientCas}-${finding.direction}`}
                metadata={finding.description}
                text={buildPhText(finding, describeAbove, describeBelow)}
                variant={severityToBannerVariant[finding.severity]}
            />
        ))}
    </PanelSection>
);

export default PhWarningsSection;
